import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=c352395e&scoped=true&"
import script from "./Automation.vue?vue&type=script&lang=js&"
export * from "./Automation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c352395e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c352395e')) {
      api.createRecord('c352395e', component.options)
    } else {
      api.reload('c352395e', component.options)
    }
    module.hot.accept("./Automation.vue?vue&type=template&id=c352395e&scoped=true&", function () {
      api.rerender('c352395e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation.vue"
export default component.exports